"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACAvatar = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var antd_1 = require("antd");
var helpers_1 = require("../utils/helpers");
var ACAvatar = function (props) {
    var name = (props === null || props === void 0 ? void 0 : props.label) || '';
    var isValidName = name && name !== 'Unknown';
    var size = (props === null || props === void 0 ? void 0 : props.size) || 'small';
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex gap-1 items-center", children: [(0, jsx_runtime_1.jsx)(antd_1.Avatar, { size: size, className: "!min-w-[24px] !w-[24px]", style: isValidName
                    ? { backgroundColor: helpers_1.Helper.stringToColour(name) }
                    : undefined, children: isValidName && ((0, jsx_runtime_1.jsx)("span", { className: "uppercase", children: helpers_1.Helper.initials(name) })) }), (0, jsx_runtime_1.jsx)("span", { className: "capitalize line-clamp-1", children: name })] }));
};
exports.ACAvatar = ACAvatar;
